// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file tagn/v1/notes.proto (package tagn.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { User } from "./common_pb";
import { file_tagn_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tagn/v1/notes.proto.
 */
export const file_tagn_v1_notes: GenFile = /*@__PURE__*/
  fileDesc("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", [file_tagn_v1_common]);

/**
 * Note as seen by the requesting user.
 *
 * @generated from message tagn.v1.Note
 */
export type Note = Message<"tagn.v1.Note"> & {
  /**
   * Client generated UUID.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: tagn.v1.NoteKind kind = 2;
   */
  kind: NoteKind;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * Markdown content. Tags are written inline as #Tag or #Tag:Sub.
   *
   * @generated from field: string content = 4;
   */
  content: string;

  /**
   * Tags derived from title and content by the server.
   *
   * @generated from field: repeated string tags = 5;
   */
  tags: string[];

  /**
   * @generated from field: bool pinned = 6;
   */
  pinned: boolean;

  /**
   * @generated from field: bool archived = 7;
   */
  archived: boolean;

  /**
   * @generated from field: bool deleted = 8;
   */
  deleted: boolean;

  /**
   * Monotonic server version used for optimistic concurrency.
   *
   * @generated from field: int64 version = 9;
   */
  version: bigint;

  /**
   * @generated from field: int64 created_at_ms = 10;
   */
  createdAtMs: bigint;

  /**
   * @generated from field: int64 updated_at_ms = 11;
   */
  updatedAtMs: bigint;

  /**
   * @generated from field: string owner_id = 12;
   */
  ownerId: string;

  /**
   * @generated from field: tagn.v1.Role role = 13;
   */
  role: Role;

  /**
   * @generated from field: bool shared = 14;
   */
  shared: boolean;
};

/**
 * Describes the message tagn.v1.Note.
 * Use `create(NoteSchema)` to create a new message.
 */
export const NoteSchema: GenMessage<Note> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 0);

/**
 * NoteChange is a local mutation the client wants to persist.
 *
 * @generated from message tagn.v1.NoteChange
 */
export type NoteChange = Message<"tagn.v1.NoteChange"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: tagn.v1.NoteKind kind = 2;
   */
  kind: NoteKind;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;

  /**
   * @generated from field: bool pinned = 5;
   */
  pinned: boolean;

  /**
   * @generated from field: bool archived = 6;
   */
  archived: boolean;

  /**
   * @generated from field: bool deleted = 7;
   */
  deleted: boolean;

  /**
   * Version the change is based on (0 for new notes).
   *
   * @generated from field: int64 base_version = 8;
   */
  baseVersion: bigint;

  /**
   * @generated from field: int64 updated_at_ms = 9;
   */
  updatedAtMs: bigint;
};

/**
 * Describes the message tagn.v1.NoteChange.
 * Use `create(NoteChangeSchema)` to create a new message.
 */
export const NoteChangeSchema: GenMessage<NoteChange> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 1);

/**
 * ChangeResult is the outcome of one pushed change.
 *
 * @generated from message tagn.v1.ChangeResult
 */
export type ChangeResult = Message<"tagn.v1.ChangeResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: tagn.v1.ChangeStatus status = 2;
   */
  status: ChangeStatus;

  /**
   * Current server state of the note (if it exists and is accessible).
   *
   * @generated from field: tagn.v1.Note note = 3;
   */
  note?: Note | undefined;
};

/**
 * Describes the message tagn.v1.ChangeResult.
 * Use `create(ChangeResultSchema)` to create a new message.
 */
export const ChangeResultSchema: GenMessage<ChangeResult> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 2);

/**
 * SyncRequest is the request message of Sync.
 *
 * @generated from message tagn.v1.SyncRequest
 */
export type SyncRequest = Message<"tagn.v1.SyncRequest"> & {
  /**
   * Opaque cursor from the previous response; empty for a full sync.
   *
   * @generated from field: string cursor = 1;
   */
  cursor: string;

  /**
   * @generated from field: repeated tagn.v1.NoteChange changes = 2;
   */
  changes: NoteChange[];
};

/**
 * Describes the message tagn.v1.SyncRequest.
 * Use `create(SyncRequestSchema)` to create a new message.
 */
export const SyncRequestSchema: GenMessage<SyncRequest> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 3);

/**
 * SyncResponse is the response message of Sync.
 *
 * @generated from message tagn.v1.SyncResponse
 */
export type SyncResponse = Message<"tagn.v1.SyncResponse"> & {
  /**
   * @generated from field: repeated tagn.v1.ChangeResult results = 1;
   */
  results: ChangeResult[];

  /**
   * Notes changed since the cursor.
   *
   * @generated from field: repeated tagn.v1.Note notes = 2;
   */
  notes: Note[];

  /**
   * Notes the user lost access to since the cursor.
   *
   * @generated from field: repeated string removed_ids = 3;
   */
  removedIds: string[];

  /**
   * @generated from field: string cursor = 4;
   */
  cursor: string;

  /**
   * True if more changes are available; call Sync again with the new cursor.
   *
   * @generated from field: bool has_more = 5;
   */
  hasMore: boolean;
};

/**
 * Describes the message tagn.v1.SyncResponse.
 * Use `create(SyncResponseSchema)` to create a new message.
 */
export const SyncResponseSchema: GenMessage<SyncResponse> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 4);

/**
 * Member of a note.
 *
 * @generated from message tagn.v1.Member
 */
export type Member = Message<"tagn.v1.Member"> & {
  /**
   * @generated from field: tagn.v1.User user = 1;
   */
  user?: User | undefined;

  /**
   * @generated from field: tagn.v1.Role role = 2;
   */
  role: Role;
};

/**
 * Describes the message tagn.v1.Member.
 * Use `create(MemberSchema)` to create a new message.
 */
export const MemberSchema: GenMessage<Member> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 5);

/**
 * ShareNoteRequest is the request message of ShareNote.
 *
 * @generated from message tagn.v1.ShareNoteRequest
 */
export type ShareNoteRequest = Message<"tagn.v1.ShareNoteRequest"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: tagn.v1.Role role = 3;
   */
  role: Role;
};

/**
 * Describes the message tagn.v1.ShareNoteRequest.
 * Use `create(ShareNoteRequestSchema)` to create a new message.
 */
export const ShareNoteRequestSchema: GenMessage<ShareNoteRequest> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 6);

/**
 * ShareNoteResponse is the response message of ShareNote.
 *
 * @generated from message tagn.v1.ShareNoteResponse
 */
export type ShareNoteResponse = Message<"tagn.v1.ShareNoteResponse"> & {
  /**
   * @generated from field: tagn.v1.Member member = 1;
   */
  member?: Member | undefined;
};

/**
 * Describes the message tagn.v1.ShareNoteResponse.
 * Use `create(ShareNoteResponseSchema)` to create a new message.
 */
export const ShareNoteResponseSchema: GenMessage<ShareNoteResponse> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 7);

/**
 * UnshareNoteRequest is the request message of UnshareNote.
 *
 * @generated from message tagn.v1.UnshareNoteRequest
 */
export type UnshareNoteRequest = Message<"tagn.v1.UnshareNoteRequest"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * Describes the message tagn.v1.UnshareNoteRequest.
 * Use `create(UnshareNoteRequestSchema)` to create a new message.
 */
export const UnshareNoteRequestSchema: GenMessage<UnshareNoteRequest> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 8);

/**
 * UnshareNoteResponse is the response message of UnshareNote.
 *
 * @generated from message tagn.v1.UnshareNoteResponse
 */
export type UnshareNoteResponse = Message<"tagn.v1.UnshareNoteResponse"> & {
};

/**
 * Describes the message tagn.v1.UnshareNoteResponse.
 * Use `create(UnshareNoteResponseSchema)` to create a new message.
 */
export const UnshareNoteResponseSchema: GenMessage<UnshareNoteResponse> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 9);

/**
 * ListMembersRequest is the request message of ListMembers.
 *
 * @generated from message tagn.v1.ListMembersRequest
 */
export type ListMembersRequest = Message<"tagn.v1.ListMembersRequest"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;
};

/**
 * Describes the message tagn.v1.ListMembersRequest.
 * Use `create(ListMembersRequestSchema)` to create a new message.
 */
export const ListMembersRequestSchema: GenMessage<ListMembersRequest> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 10);

/**
 * ListMembersResponse is the response message of ListMembers.
 *
 * @generated from message tagn.v1.ListMembersResponse
 */
export type ListMembersResponse = Message<"tagn.v1.ListMembersResponse"> & {
  /**
   * @generated from field: repeated tagn.v1.Member members = 1;
   */
  members: Member[];

  /**
   * Public share link token, empty if not shared via link.
   *
   * @generated from field: string link_token = 2;
   */
  linkToken: string;
};

/**
 * Describes the message tagn.v1.ListMembersResponse.
 * Use `create(ListMembersResponseSchema)` to create a new message.
 */
export const ListMembersResponseSchema: GenMessage<ListMembersResponse> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 11);

/**
 * CreateShareLinkRequest is the request message of CreateShareLink.
 *
 * @generated from message tagn.v1.CreateShareLinkRequest
 */
export type CreateShareLinkRequest = Message<"tagn.v1.CreateShareLinkRequest"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;
};

/**
 * Describes the message tagn.v1.CreateShareLinkRequest.
 * Use `create(CreateShareLinkRequestSchema)` to create a new message.
 */
export const CreateShareLinkRequestSchema: GenMessage<CreateShareLinkRequest> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 12);

/**
 * CreateShareLinkResponse is the response message of CreateShareLink.
 *
 * @generated from message tagn.v1.CreateShareLinkResponse
 */
export type CreateShareLinkResponse = Message<"tagn.v1.CreateShareLinkResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message tagn.v1.CreateShareLinkResponse.
 * Use `create(CreateShareLinkResponseSchema)` to create a new message.
 */
export const CreateShareLinkResponseSchema: GenMessage<CreateShareLinkResponse> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 13);

/**
 * RevokeShareLinkRequest is the request message of RevokeShareLink.
 *
 * @generated from message tagn.v1.RevokeShareLinkRequest
 */
export type RevokeShareLinkRequest = Message<"tagn.v1.RevokeShareLinkRequest"> & {
  /**
   * @generated from field: string note_id = 1;
   */
  noteId: string;
};

/**
 * Describes the message tagn.v1.RevokeShareLinkRequest.
 * Use `create(RevokeShareLinkRequestSchema)` to create a new message.
 */
export const RevokeShareLinkRequestSchema: GenMessage<RevokeShareLinkRequest> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 14);

/**
 * RevokeShareLinkResponse is the response message of RevokeShareLink.
 *
 * @generated from message tagn.v1.RevokeShareLinkResponse
 */
export type RevokeShareLinkResponse = Message<"tagn.v1.RevokeShareLinkResponse"> & {
};

/**
 * Describes the message tagn.v1.RevokeShareLinkResponse.
 * Use `create(RevokeShareLinkResponseSchema)` to create a new message.
 */
export const RevokeShareLinkResponseSchema: GenMessage<RevokeShareLinkResponse> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 15);

/**
 * GetSharedNoteRequest is the request message of GetSharedNote.
 *
 * @generated from message tagn.v1.GetSharedNoteRequest
 */
export type GetSharedNoteRequest = Message<"tagn.v1.GetSharedNoteRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message tagn.v1.GetSharedNoteRequest.
 * Use `create(GetSharedNoteRequestSchema)` to create a new message.
 */
export const GetSharedNoteRequestSchema: GenMessage<GetSharedNoteRequest> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 16);

/**
 * GetSharedNoteResponse is the response message of GetSharedNote.
 *
 * @generated from message tagn.v1.GetSharedNoteResponse
 */
export type GetSharedNoteResponse = Message<"tagn.v1.GetSharedNoteResponse"> & {
  /**
   * @generated from field: tagn.v1.Note note = 1;
   */
  note?: Note | undefined;

  /**
   * @generated from field: string owner_name = 2;
   */
  ownerName: string;
};

/**
 * Describes the message tagn.v1.GetSharedNoteResponse.
 * Use `create(GetSharedNoteResponseSchema)` to create a new message.
 */
export const GetSharedNoteResponseSchema: GenMessage<GetSharedNoteResponse> = /*@__PURE__*/
  messageDesc(file_tagn_v1_notes, 17);

/**
 * NoteKind distinguishes free text notes from todo lists.
 *
 * @generated from enum tagn.v1.NoteKind
 */
export enum NoteKind {
  /**
   * @generated from enum value: NOTE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTE_KIND_TEXT = 1;
   */
  TEXT = 1,

  /**
   * @generated from enum value: NOTE_KIND_TODO = 2;
   */
  TODO = 2,
}

/**
 * Describes the enum tagn.v1.NoteKind.
 */
export const NoteKindSchema: GenEnum<NoteKind> = /*@__PURE__*/
  enumDesc(file_tagn_v1_notes, 0);

/**
 * Role of a user on a note.
 *
 * @generated from enum tagn.v1.Role
 */
export enum Role {
  /**
   * @generated from enum value: ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ROLE_OWNER = 1;
   */
  OWNER = 1,

  /**
   * @generated from enum value: ROLE_EDITOR = 2;
   */
  EDITOR = 2,

  /**
   * @generated from enum value: ROLE_VIEWER = 3;
   */
  VIEWER = 3,
}

/**
 * Describes the enum tagn.v1.Role.
 */
export const RoleSchema: GenEnum<Role> = /*@__PURE__*/
  enumDesc(file_tagn_v1_notes, 1);

/**
 * ChangeStatus reports how a pushed change was handled.
 *
 * @generated from enum tagn.v1.ChangeStatus
 */
export enum ChangeStatus {
  /**
   * @generated from enum value: CHANGE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHANGE_STATUS_APPLIED = 1;
   */
  APPLIED = 1,

  /**
   * @generated from enum value: CHANGE_STATUS_CONFLICT = 2;
   */
  CONFLICT = 2,

  /**
   * @generated from enum value: CHANGE_STATUS_FORBIDDEN = 3;
   */
  FORBIDDEN = 3,

  /**
   * @generated from enum value: CHANGE_STATUS_INVALID = 4;
   */
  INVALID = 4,
}

/**
 * Describes the enum tagn.v1.ChangeStatus.
 */
export const ChangeStatusSchema: GenEnum<ChangeStatus> = /*@__PURE__*/
  enumDesc(file_tagn_v1_notes, 2);

/**
 * NoteService provides offline-first synchronisation and sharing of notes.
 *
 * @generated from service tagn.v1.NoteService
 */
export const NoteService: GenService<{
  /**
   * Sync pushes local changes and pulls all remote changes since a cursor.
   *
   * @generated from rpc tagn.v1.NoteService.Sync
   */
  sync: {
    methodKind: "unary";
    input: typeof SyncRequestSchema;
    output: typeof SyncResponseSchema;
  },
  /**
   * ShareNote grants another existing user access to a note.
   *
   * @generated from rpc tagn.v1.NoteService.ShareNote
   */
  shareNote: {
    methodKind: "unary";
    input: typeof ShareNoteRequestSchema;
    output: typeof ShareNoteResponseSchema;
  },
  /**
   * UnshareNote revokes a user's access. A member may remove themselves.
   *
   * @generated from rpc tagn.v1.NoteService.UnshareNote
   */
  unshareNote: {
    methodKind: "unary";
    input: typeof UnshareNoteRequestSchema;
    output: typeof UnshareNoteResponseSchema;
  },
  /**
   * ListMembers lists everybody with access to a note.
   *
   * @generated from rpc tagn.v1.NoteService.ListMembers
   */
  listMembers: {
    methodKind: "unary";
    input: typeof ListMembersRequestSchema;
    output: typeof ListMembersResponseSchema;
  },
  /**
   * CreateShareLink creates (or returns) a public read-only link.
   *
   * @generated from rpc tagn.v1.NoteService.CreateShareLink
   */
  createShareLink: {
    methodKind: "unary";
    input: typeof CreateShareLinkRequestSchema;
    output: typeof CreateShareLinkResponseSchema;
  },
  /**
   * RevokeShareLink disables the public link of a note.
   *
   * @generated from rpc tagn.v1.NoteService.RevokeShareLink
   */
  revokeShareLink: {
    methodKind: "unary";
    input: typeof RevokeShareLinkRequestSchema;
    output: typeof RevokeShareLinkResponseSchema;
  },
  /**
   * GetSharedNote resolves a public share link (no authentication required).
   *
   * @generated from rpc tagn.v1.NoteService.GetSharedNote
   */
  getSharedNote: {
    methodKind: "unary";
    input: typeof GetSharedNoteRequestSchema;
    output: typeof GetSharedNoteResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tagn_v1_notes, 0);

